import axios from "axios";
import {getToken} from "../../helper"
import pubsub from "@viewlift/pubsub";
import { logoutUser } from "../../../../../clevertap";
import { signOutKeycloakSession,isKeycloakEnabled, getKeycloakRefreshToken } from "../../../../../OnBoarding-V2/LoginV2/Helpers/keycloakLogin";

export let logout = async() => {
  logoutUser()
  pubsub.publish('apploading',true)
  let apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl
  let site = window?.app_data?.site?.siteInternalName
  let token = await getToken(token => { return token })
  const keycloakRefreshToken = isKeycloakEnabled() && getKeycloakRefreshToken();
    return axios({
      method: 'POST',
      url: `${apiBaseUrl}/identity/signout`,
      params: { site: site,
      platform : "web_browser"
      },
      headers: { 
        Authorization: token,
        ...(keycloakRefreshToken && {
          'x-keyclock-refreshtoken' : keycloakRefreshToken,
        }),
        'x-api-key': window?.xApiKey
      }
      })
}
